export default __webpack_public_path__ + "static/media/stainless-steel.35ce10bd.jpeg";